$(document).ready(function() {
    $('.user-share').on('click', function() {
        var id = $(this).data('id');
        var nome = $(this).data('nome');
        var type = $(this).data('type');
        var url = window.location.href.split('?')[0] + '?ref=share';
        
        var title = nome;
        var text = 'Guarda cosa ho trovato su iDoctors!';

        if (type == 'clinica') {
            text = 'Ti consiglio la clinica ' + nome + ' che ho trovato su iDoctors!';
        }

        if (type == 'medico') {
            text = 'Ti consiglio il medico ' + nome + ' che ho trovato su iDoctors!';
        }

        if (navigator.share) {
            var shareData = {
                title,
                text,
                url,
                facebookID: 775841059220011,
                closeAfterShare: false,
                useNativeOnDesktop: false,
            };
            
            navigator.share(shareData)
            .then(() => console.log('Successful share'))
            .catch(error => console.log('Error sharing:', error));
        }
    });
});